import { render, staticRenderFns } from "./DamageShort.vue?vue&type=template&id=844b25d2&scoped=true"
import script from "./DamageShort.vue?vue&type=script&lang=ts"
export * from "./DamageShort.vue?vue&type=script&lang=ts"
import style0 from "./DamageShort.vue?vue&type=style&index=0&id=844b25d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844b25d2",
  null
  
)

export default component.exports